import { useState } from "react";
import { Col, Dropdown, Form, OverlayTrigger, Stack, Table, Tooltip } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import Select from 'react-select';
import { defaultEdge as defaultEdgeOption, defaultSheetForm } from "./stolarz_form_defaults";
import { SheetData, FormData } from "./stolarz_form_types";
import Canvas from "./stolarz_form_canvas";
import React from "react";
import "./stolarz_form_products_and_sheets.css"
import { getMaterial } from "./database_helpers";
import { DBMaterialType } from "../database_types";
import { StringToJSX } from "./StringToJSX";

interface EdgeCodeCache {
    up: string;
    setUp: (val: string) => void;
    clearUp: () => void;
    down: string;
    setDown: (val: string) => void;
    clearDown: () => void;
    left: string;
    setLeft: (val: string) => void;
    clearLeft: () => void;
    right: string;
    setRigth: (val: string) => void;
    clearRight: () => void;
}


export function getEdgeForm(
    field: any,
    control: any,
    optionsEdges: { value: string; label: string }[],
    parametrizeName: string,
    humanReadableLabel: string,
    clearEdgeCodeCache: () => void,
    setEdgeCodeCache: (val: string) => void,
) {
    const edgeCode = `${parametrizeName}.edgeCode`
    let field_orig = field;
    return <div>
        <Form.Label>Obrzeże {humanReadableLabel}</Form.Label>
        <Controller
            key={edgeCode + field.id}
            control={control}
            defaultValue={defaultEdgeOption.value}
            name={edgeCode}
            render={({ formState, fieldState, field }) => (
                <Select
                    key={edgeCode + "select" + field_orig.id}
                    defaultValue={defaultEdgeOption}
                    options={optionsEdges}
                    value={optionsEdges.find(c => c.value === field.value)}
                    onChange={val => {
                        if (val?.value === "") {
                            clearEdgeCodeCache()
                        } else {
                            if (val?.value !== undefined) {
                                setEdgeCodeCache(val?.value)
                            }
                        }
                        return field.onChange(val?.value)
                    }} />
            )}
        />
    </div>;
}

function EdgesModalMenu({ field, productIndex, index, optionsEdges, update, defaultEdgeCode, edgeCodeCache }: {
    field: any | SheetData,
    productIndex: number;
    index: number;
    optionsEdges: { value: string; label: string }[],
    update: any;
    defaultEdgeCode: string;
    edgeCodeCache: EdgeCodeCache
}) {
    const { watch, control } = useFormContext<FormData>();
    // const [show, setShow] = useState(false);

    let sheet: SheetData = watch(`products.${productIndex}.sheets.${index}`);
    return <>
        <Dropdown autoClose="outside" title="" id={`bg-nested-dropdown-edges-${productIndex}-${index}`} >
            <Dropdown.Toggle tabIndex={-1} variant="outline-secondary" style={{ border: 0 }} >
                Wybierz PCV
            </Dropdown.Toggle>
            <Dropdown.Menu >
                <Container className="dropdown-item" style={{ backgroundColor: "transparent" }}>
                    {/* transparent background prevents color flickering on click - do not know how to do it properly */}
                    {<Canvas sheet={sheet} height={200} width={200} field={field} optionsEdges={optionsEdges} parametrizeName={`products.${productIndex}.sheets.${index}.edgeUp`}></Canvas>}
                    {EdgeQuickAction(watch(`products.${productIndex}.sheets.${index}`), index, update, defaultEdgeCode, edgeCodeCache)}
                    <Row>
                        <Col>
                            {getEdgeForm(field, control, optionsEdges, `products.${productIndex}.sheets.${index}.edgeUp`, "długość 1", edgeCodeCache.clearUp, edgeCodeCache.setUp)}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {getEdgeForm(field, control, optionsEdges, `products.${productIndex}.sheets.${index}.edgeDown`, "długość 2", edgeCodeCache.clearDown, edgeCodeCache.setDown)}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {getEdgeForm(field, control, optionsEdges, `products.${productIndex}.sheets.${index}.edgeLeft`, "szerokość 1", edgeCodeCache.clearLeft, edgeCodeCache.setLeft)}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {getEdgeForm(field, control, optionsEdges, `products.${productIndex}.sheets.${index}.edgeRight`, "szerokość 2", edgeCodeCache.clearRight, edgeCodeCache.setRigth)}
                        </Col>
                    </Row>
                </Container>
            </Dropdown.Menu>
        </Dropdown>
        {/* <Button variant="secondary" onClick={() => setShow((s) => !s)} className="me-2">
            Wybierz PCV
        </Button> */}
        {/* {watch(`products.${productIndex}.sheets.${index}.edgeUp.edgeCode`) === "" ? "" :
                <Badge bg="info">D1</Badge>}
            {watch(`products.${productIndex}.sheets.${index}.edgeDown.edgeCode`) === "" ? "" :
                <Badge bg="info">D2</Badge>}
            {watch(`products.${productIndex}.sheets.${index}.edgeLeft.edgeCode`) === "" ? "" :
                <Badge bg="info">S1</Badge>}
            {watch(`products.${productIndex}.sheets.${index}.edgeRight.edgeCode`) === "" ? "" :
                <Badge bg="info">S2</Badge>} */}
        {/* <Offcanvas show={show} onHide={() => setShow(false)} backdrop="true" {...props}>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Obrzeża</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                {<Canvas sheet={sheet} height={200} width={200} field={field} optionsEdges={optionsEdges} parametrizeName={`products.${productIndex}.sheets.${index}.edgeUp`}></Canvas>}
                <Container>
                    {EdgeQuickAction(watch(`products.${productIndex}.sheets.${index}`), index, update)}
                    <Row>
                        <Col>
                            {getEdgeForm(field, control, optionsEdges, `products.${productIndex}.sheets.${index}.edgeUp`, "długość 1")}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {getEdgeForm(field, control, optionsEdges, `products.${productIndex}.sheets.${index}.edgeDown`, "długość 2")}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {getEdgeForm(field, control, optionsEdges, `products.${productIndex}.sheets.${index}.edgeLeft`, "szerokość 1")}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {getEdgeForm(field, control, optionsEdges, `products.${productIndex}.sheets.${index}.edgeRight`, "szerokość 2")}
                        </Col>
                    </Row>
                </Container>
            </Offcanvas.Body>
        </Offcanvas> */}
    </>;
}
export function ProductSheetsTable({ productIndex, optionsEdges, showPreview, optionsMaterials, defaultEdgeCode, clearEdgeCodeCacheHooks, materialsDB }: {
    productIndex: number;
    optionsEdges: { value: string; label: string; }[];
    showPreview: boolean;
    optionsMaterials: { value: string; label: string; }[];
    defaultEdgeCode: string;
    clearEdgeCodeCacheHooks: (() => void)[];
    materialsDB: DBMaterialType[];
}) {
    const { watch, trigger, clearErrors, formState: { errors }, register, control, setValue, getValues } = useFormContext<FormData>();
    const { fields, append, remove, update } = useFieldArray({ name: `products.${productIndex}.sheets`, }); // todo use type SheetData[]
    const [edgeLastValueUp, setEdgeLastValueUp] = useState<string[]>([]);
    const [edgeLastValueDown, setEdgeLastValueDown] = useState<string[]>([]);
    const [edgeLastValueLeft, setEdgeLastValueLeft] = useState<string[]>([]);
    const [edgeLastValueRight, setEdgeLastValueRight] = useState<string[]>([]);
    clearEdgeCodeCacheHooks.length = 0;

    function swapWidthLength(sheets: SheetData[], index: number, edgeCodeCache: EdgeCodeCache) {
        // cache is fun!
        const [up, down, left, right] = [edgeCodeCache.up, edgeCodeCache.down, edgeCodeCache.left, edgeCodeCache.right]
        if (left === "") {
            edgeCodeCache.clearDown()
        } else {
            edgeCodeCache.setDown(left);
        }
        if (right === "") {
            edgeCodeCache.clearUp()
        } else {
            edgeCodeCache.setUp(right);
        }
        if (down === "") {
            edgeCodeCache.clearLeft()
        } else {
            edgeCodeCache.setLeft(down);
        }
        if (up === "") {
            edgeCodeCache.clearRight()
        } else {
            edgeCodeCache.setRigth(up);
        }

        let sheet = sheets[index];
        [sheet.width, sheet.length] = [sheet.length, sheet.width];
        [sheet.edgeDown, sheet.edgeUp,
        sheet.edgeLeft, sheet.edgeRight] = [
                sheet.edgeLeft, sheet.edgeRight,
                sheet.edgeDown, sheet.edgeUp,
            ];
        update(index, sheet);
    }

    return <>
        <Form.Group controlId={`formatki-${productIndex}`}>
            <Table striped borderless size="sm">
                <thead>
                    <tr>
                        <th>#</th>
                        <OverlayTrigger overlay={<Tooltip>Będzie wydrukowana na etykiecie</Tooltip>}>
                            <th>
                                Nazwaⓘ
                            </th>
                        </OverlayTrigger>
                        <OverlayTrigger overlay={<Tooltip>Będzie wydrukowana na etykiecie (druga linijka)</Tooltip>}>
                            <th>
                                Uwagiⓘ
                            </th>
                        </OverlayTrigger>

                        <OverlayTrigger overlay={<Tooltip>Ustaw materiał (uwaga na grubość płyty!). Zaznacz czy jest dla ciebie ważny kierunek usłojenia. Nie każda płyta posiada usłojenie.</Tooltip>}>
                            <th>
                                Materiał płyty i usłojenieⓘ
                            </th>
                        </OverlayTrigger>
                        <OverlayTrigger overlay={<Tooltip>Długość i szerokość w minimetrach</Tooltip>}>
                            <th>
                                Dł/szer (mm)ⓘ
                            </th>
                        </OverlayTrigger>
                        {/* <OverlayTrigger overlay={<Tooltip></Tooltip>}> */}
                        <th>
                            Sztuk
                        </th>
                        {/* </OverlayTrigger> */}
                        <OverlayTrigger overlay={<Tooltip>Zaznacz która obrzeża mają być oklejone. Jeśli coś ma być oklejone, pokaże to ikona D i S (Długość, Szerokość)</Tooltip>}>
                            <th>
                                Obrzeżaⓘ
                            </th>
                        </OverlayTrigger>
                        {showPreview &&
                            <th>Podgląd</th>
                        }
                    </tr>
                </thead>
                <tbody>
                    {fields.map((field, index) => {
                        const edgeCodeCache: EdgeCodeCache = {
                            up: edgeLastValueUp[index],
                            setUp: (val: string) => { if (!val) { return }; edgeLastValueUp[index] = val; setEdgeLastValueUp(edgeLastValueUp) },
                            clearUp: () => { edgeLastValueUp[index] = ""; setEdgeLastValueUp(edgeLastValueUp) },
                            down: edgeLastValueDown[index],
                            setDown: (val: string) => { if (!val) { return }; edgeLastValueDown[index] = val; setEdgeLastValueDown(edgeLastValueDown) },
                            clearDown: () => { edgeLastValueDown[index] = ""; setEdgeLastValueDown(edgeLastValueDown) },
                            left: edgeLastValueLeft[index],
                            setLeft: (val: string) => { if (!val) { return }; edgeLastValueLeft[index] = val; setEdgeLastValueLeft(edgeLastValueLeft) },
                            clearLeft: () => { edgeLastValueLeft[index] = ""; setEdgeLastValueLeft(edgeLastValueLeft) },
                            right: edgeLastValueRight[index],
                            setRigth: (val: string) => { if (!val) { return }; edgeLastValueRight[index] = val; setEdgeLastValueRight(edgeLastValueRight) },
                            clearRight: () => { edgeLastValueRight[index] = ""; setEdgeLastValueRight(edgeLastValueRight) },
                        }

                        clearEdgeCodeCacheHooks.push(() => {
                            edgeCodeCache.clearDown();
                            edgeCodeCache.clearUp();
                            edgeCodeCache.clearLeft();
                            edgeCodeCache.clearRight();
                        })
                        const sheet = watch(`products.${productIndex}.sheets.${index}`);
                        const material = getMaterial(materialsDB, sheet.materialCode);
                        return <tr>
                            <td>
                                <Dropdown >
                                    <Dropdown.Toggle id={`dropdown-product-actions-${field.id}`} variant="outline-secondary" style={{ border: 0, }}>
                                        {`${index + 1}.`}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {/* TODO WTF!! this duplicate breaks useGrain boolean!! */}
                                        <Dropdown.Item eventKey={1} as={Button}>
                                            <Row>
                                                <Button variant="secondary" size="sm" onClick={() => {
                                                    const sheets: SheetData[] = getValues(`products.${productIndex}.sheets`);
                                                    // const productData: ProductData = watch(`products.${productIndex}`);
                                                    // insert(productIndex, { ...productData });
                                                    // append({ ...defaultSheetForm });
                                                    append({ ...sheets[index] });
                                                    // swap(index, sheets.length); // this breaks boolean value!!
                                                }}>Duplikuj</Button>
                                            </Row>
                                        </Dropdown.Item>
                                        <Dropdown.Item eventKey={2} as={Button}>
                                            <Row>
                                                <Button variant="secondary" size="sm" onClick={() => {
                                                    setValue(`products.${productIndex}.sheets.${index}`, { ...defaultSheetForm })
                                                }}>Reset formatki</Button>
                                            </Row>
                                        </Dropdown.Item>
                                        <Dropdown.Divider></Dropdown.Divider>
                                        <Dropdown.Item eventKey={3} as={Button}>
                                            <Row>
                                                <Button variant="danger" size="sm" onClick={() => remove(index)}>✖ Usuń</Button>
                                            </Row>
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                            <td>
                                <Form.Control as="textarea" rows={2} key={`products.${productIndex}.sheets.${index}.itemName` + field.id} {...register(`products.${productIndex}.sheets.${index}.itemName`)} />
                                {errors.products?.[productIndex]?.sheets?.[index]?.itemName &&
                                    <Form.Text className="text-danger">
                                        {errors.products?.[productIndex]?.sheets?.[index]?.itemName?.message?.toString()}
                                    </Form.Text>}
                            </td>
                            <td>
                                <Form.Control as="textarea" rows={2} key={`products.${productIndex}.sheets.${index}.itemComment` + field.id} {...register(`products.${productIndex}.sheets.${index}.itemComment`)} />
                                {errors.products?.[productIndex]?.sheets?.[index]?.itemComment &&
                                    <Form.Text className="text-danger">
                                        {errors.products?.[productIndex]?.sheets?.[index]?.itemComment?.message?.toString()}
                                    </Form.Text>}
                            </td>
                            <td>
                                <Stack direction="horizontal">
                                    <div style={{ minWidth: 300 }}>
                                        <Controller
                                            control={control}
                                            key={`products.${productIndex}.sheets.${index}.materialCode` + field.id}
                                            rules={{ required: true }}
                                            name={`products.${productIndex}.sheets.${index}.materialCode`}
                                            render={({ formState, fieldState, field }) => (
                                                <Select
                                                    classNamePrefix="lp-copy-sel"
                                                    className="btn-block"
                                                    placeholder="--Wybierz materiał--"
                                                    options={optionsMaterials}
                                                    value={optionsMaterials.find(c => c.value === field.value)}
                                                    onChange={val => {
                                                        clearErrors(`products.${productIndex}.sheets.${index}`);
                                                        field.onChange(val?.value);
                                                        trigger(`products.${productIndex}.sheets.${index}`);
                                                    }} />
                                            )} />

                                        {errors.products?.[productIndex]?.sheets?.[index]?.materialCode &&
                                            <Form.Text className="text-danger">
                                                {errors.products?.[productIndex]?.sheets?.[index]?.materialCode?.message?.toString()}
                                            </Form.Text>}
                                    </div>
                                    <OverlayTrigger overlay={<Tooltip>Zaznacz czy jest dla ciebie ważny kierunek usłojenia. <strong>{material?.graining ? `Materiał posiada usłojenie` : `Materiał nie posiada usłojenia. Ozdnacz aby zoptymailizować rozkrój`}</strong></Tooltip>}>
                                        <div>
                                            <Form.Check
                                                className={material?.graining !== sheet.useGrain ? "custom-checkbox-warning" : ""}
                                                key={`products.${productIndex}.sheets.${index}.useGrain` + field.id} type='checkbox' label="" {...register(`products.${productIndex}.sheets.${index}.useGrain`)} />
                                            {errors.products?.[productIndex]?.sheets?.[index]?.useGrain &&
                                                <Form.Text className="text-danger">
                                                    {errors.products?.[productIndex]?.sheets?.[index]?.useGrain?.message?.toString()}
                                                </Form.Text>}
                                        </div>
                                    </OverlayTrigger>
                                </Stack>
                            </td>
                            <td>
                                <Stack direction="horizontal">
                                    <Form.Control style={{ minWidth: 60 }} key={`products.${productIndex}.sheets.${index}.length` + field.id} type="number" min={0} defaultValue={100}
                                        {...register(`products.${productIndex}.sheets.${index}.length`, {
                                            valueAsNumber: true,
                                            // onChange: (e) => { trigger(`products.${productIndex}.sheets.${index}`)},
                                        })
                                        } />
                                    <OverlayTrigger overlay={<Tooltip>Zamień długość i szerokość - zmień kierunek usłojenia. Krawędzie zostaną automatycznie zmienione.</Tooltip>}>
                                        <Button style={{ maxWidth: 20, paddingLeft: 3, border: 0 }} tabIndex={-1} variant="outline-secondary" onClick={() => swapWidthLength(watch(`products.${productIndex}.sheets`), index, edgeCodeCache)}>↔</Button>
                                    </OverlayTrigger>
                                    <Form.Control style={{ minWidth: 60 }} key={`products.${productIndex}.sheets.${index}.width` + field.id} type="number" min={0} defaultValue={100} {...register(`products.${productIndex}.sheets.${index}.width`, { valueAsNumber: true, })} />
                                </Stack>
                                {errors.products?.[productIndex]?.sheets?.[index] &&
                                    <Form.Text className="text-danger">
                                        {errors.products?.[productIndex]?.sheets?.[index]?.message?.toString()}
                                    </Form.Text>}
                                {(errors.products?.[productIndex]?.sheets?.[index]?.width || errors.products?.[productIndex]?.sheets?.[index]?.length) &&
                                    <Form.Text className="text-danger">
                                        <StringToJSX domString={errors.products?.[productIndex]?.sheets?.[index]?.width?.message?.toString() || errors.products?.[productIndex]?.sheets?.[index]?.length?.message?.toString() || ""} />
                                    </Form.Text>}
                            </td>
                            <td>
                                <Form.Control key={`products.${productIndex}.sheets.${index}.amount` + field.id} type="number" min={0} defaultValue={1} {...register(`products.${productIndex}.sheets.${index}.amount`, { valueAsNumber: true })} />
                                {errors.products?.[productIndex]?.sheets?.[index]?.amount &&
                                    <Form.Text className="text-danger">
                                        {errors.products?.[productIndex]?.sheets?.[index]?.amount?.message?.toString()}
                                    </Form.Text>}
                            </td>
                            <td>
                                <Stack direction="horizontal" gap={2} >
                                    <EdgesModalMenu key={productIndex.toString() + index.toString() + field.id} field={field}
                                        productIndex={productIndex} index={index}
                                        optionsEdges={optionsEdges} update={update} defaultEdgeCode={defaultEdgeCode} edgeCodeCache={edgeCodeCache}></EdgesModalMenu>
                                    <div className="d-none d-xxl-block">
                                        {/* hide on small screens - in fact it needs a big screen */}
                                        {EdgeQuickAction(watch(`products.${productIndex}.sheets.${index}`), index, update, defaultEdgeCode, edgeCodeCache)}
                                    </div>
                                </Stack>
                            </td>
                            {showPreview &&
                                <td>
                                    <Canvas sheet={watch(`products.${productIndex}.sheets.${index}`)} height={70} width={70} field={field} optionsEdges={optionsEdges} parametrizeName={`products.${productIndex}.sheets.${index}.edgeUp`}></Canvas>
                                    {/* <Canvas sheet={watch(`products.${productIndex}.sheets.${index}`)} height={100} width={100}></Canvas> */}
                                </td>
                            }
                        </tr>;
                    })}
                    <tr>
                        <td colSpan={9}>
                        <Button variant="secondary" size="sm" onClick={() => {
                            const sheets: SheetData[] = watch(`products.${productIndex}.sheets`);
                            if (sheets.length === 0) {
                                append({ ...defaultSheetForm });
                            } else {
                                append({ ...sheets[sheets.length - 1] });
                            }
                        }}>Dodaj formatkę
                        </Button>
</td>
                    </tr>
                </tbody>

            </Table>
        </Form.Group>
    </>;
}
function EdgeQuickAction(sheet: SheetData, index: number, update: any, defaultEdgeCode: string, edgeCodeCache: EdgeCodeCache) {
    // if (sheet === undefined || sheet.edgeDown === undefined || sheet.edgeLeft === undefined || sheet.edgeRight === undefined || sheet.edgeUp === undefined) {
    //     return <></>
    // }
    const size = 30;
    return <Stack direction="vertical">
        <Stack direction="horizontal">
            <Button tabIndex={-1}
                variant={sheet.edgeUp.edgeCode === "" && sheet.edgeDown.edgeCode === "" && sheet.edgeLeft.edgeCode === "" && sheet.edgeRight.edgeCode === "" ? "outline-primary" : "light"}
                size="sm" onClick={() => {
                    edgeCodeCache.setUp(sheet.edgeUp.edgeCode);
                    edgeCodeCache.setDown(sheet.edgeDown.edgeCode);
                    edgeCodeCache.setLeft(sheet.edgeLeft.edgeCode);
                    edgeCodeCache.setRigth(sheet.edgeRight.edgeCode);
                    sheet.edgeUp.edgeCode = "";
                    sheet.edgeDown.edgeCode = "";
                    sheet.edgeLeft.edgeCode = "";
                    sheet.edgeRight.edgeCode = "";
                    update(index, sheet);
                }}> <img src="./my-icons/edge-no-sides.svg" width={size} alt="no sides"></img> </Button>
            <Button tabIndex={-1}
                variant={sheet.edgeUp.edgeCode !== "" && sheet.edgeDown.edgeCode !== "" && sheet.edgeLeft.edgeCode !== "" && sheet.edgeRight.edgeCode !== "" ? "outline-primary" : "light"}
                size="sm" onClick={() => {
                    sheet.edgeUp.edgeCode = edgeCodeCache.up || defaultEdgeCode;
                    sheet.edgeDown.edgeCode = edgeCodeCache.down || defaultEdgeCode;
                    sheet.edgeLeft.edgeCode = edgeCodeCache.left || defaultEdgeCode;
                    sheet.edgeRight.edgeCode = edgeCodeCache.right || defaultEdgeCode;
                    update(index, sheet);
                }}> <img src="./my-icons/edge-all-sides.svg" width={size} alt="all sides"></img> </Button>
            <Button tabIndex={-1}
                variant={sheet.edgeUp.edgeCode !== "" && sheet.edgeDown.edgeCode === "" && sheet.edgeLeft.edgeCode === "" && sheet.edgeRight.edgeCode === "" ? "outline-primary" : "light"}
                size="sm" onClick={() => {
                    edgeCodeCache.setDown(sheet.edgeDown.edgeCode);
                    edgeCodeCache.setLeft(sheet.edgeLeft.edgeCode);
                    edgeCodeCache.setRigth(sheet.edgeRight.edgeCode);
                    sheet.edgeUp.edgeCode = edgeCodeCache.up || defaultEdgeCode;
                    sheet.edgeDown.edgeCode = "";
                    sheet.edgeLeft.edgeCode = "";
                    sheet.edgeRight.edgeCode = "";
                    update(index, sheet);
                }}> <img src="./my-icons/edge-1-sides-long.svg" width={size} alt="1 length"></img> </Button>
            <Button tabIndex={-1}
                variant={sheet.edgeUp.edgeCode === "" && sheet.edgeDown.edgeCode === "" && sheet.edgeLeft.edgeCode !== "" && sheet.edgeRight.edgeCode === "" ? "outline-primary" : "light"}
                size="sm" onClick={() => {
                    edgeCodeCache.setUp(sheet.edgeUp.edgeCode);
                    edgeCodeCache.setDown(sheet.edgeDown.edgeCode);
                    edgeCodeCache.setRigth(sheet.edgeRight.edgeCode);
                    sheet.edgeUp.edgeCode = "";
                    sheet.edgeDown.edgeCode = "";
                    sheet.edgeLeft.edgeCode = edgeCodeCache.left || defaultEdgeCode;
                    sheet.edgeRight.edgeCode = "";
                    update(index, sheet);
                }}> <img src="./my-icons/edge-1-sides-width.svg" width={size} alt="1 width"></img> </Button>
        </Stack>
        <Stack direction="horizontal">
            <Button tabIndex={-1}
                variant={sheet.edgeUp.edgeCode !== "" && sheet.edgeDown.edgeCode !== "" && sheet.edgeLeft.edgeCode === "" && sheet.edgeRight.edgeCode === "" ? "outline-primary" : "light"}
                size="sm" onClick={() => {
                    sheet.edgeUp.edgeCode = edgeCodeCache.up || defaultEdgeCode;
                    sheet.edgeDown.edgeCode = edgeCodeCache.down || defaultEdgeCode;
                    edgeCodeCache.setLeft(sheet.edgeLeft.edgeCode);
                    sheet.edgeLeft.edgeCode = "";
                    edgeCodeCache.setRigth(sheet.edgeRight.edgeCode);
                    sheet.edgeRight.edgeCode = "";
                    update(index, sheet);
                }}> <img src="./my-icons/edge-2-sides-long.svg" width={size} alt="2 length"></img> </Button>
            <Button tabIndex={-1}
                variant={sheet.edgeUp.edgeCode === "" && sheet.edgeDown.edgeCode === "" && sheet.edgeLeft.edgeCode !== "" && sheet.edgeRight.edgeCode !== "" ? "outline-primary" : "light"}
                size="sm" onClick={() => {
                    edgeCodeCache.setUp(sheet.edgeUp.edgeCode);
                    sheet.edgeUp.edgeCode = "";
                    edgeCodeCache.setDown(sheet.edgeDown.edgeCode);
                    sheet.edgeDown.edgeCode = "";
                    sheet.edgeLeft.edgeCode = edgeCodeCache.left || defaultEdgeCode;
                    sheet.edgeRight.edgeCode = edgeCodeCache.right || defaultEdgeCode;
                    update(index, sheet);
                }}> <img src="./my-icons/edge-2-sides-width.svg" width={size} alt="2 width"></img> </Button>
            <Button tabIndex={-1}
                variant={sheet.edgeUp.edgeCode !== "" && sheet.edgeDown.edgeCode !== "" && sheet.edgeLeft.edgeCode !== "" && sheet.edgeRight.edgeCode === "" ? "outline-primary" : "light"}
                size="sm" onClick={() => {
                    sheet.edgeUp.edgeCode = edgeCodeCache.up || defaultEdgeCode;
                    sheet.edgeDown.edgeCode = edgeCodeCache.down || defaultEdgeCode;
                    sheet.edgeLeft.edgeCode = edgeCodeCache.left || defaultEdgeCode;
                    edgeCodeCache.setRigth(sheet.edgeRight.edgeCode);
                    sheet.edgeRight.edgeCode = "";
                    update(index, sheet);
                }}> <img src="./my-icons/edge-3-sides-long.svg" width={size} alt="3 length"></img> </Button>
            <Button tabIndex={-1}
                variant={sheet.edgeUp.edgeCode !== "" && sheet.edgeDown.edgeCode === "" && sheet.edgeLeft.edgeCode !== "" && sheet.edgeRight.edgeCode !== "" ? "outline-primary" : "light"}
                size="sm" onClick={() => {
                    sheet.edgeUp.edgeCode = edgeCodeCache.up || defaultEdgeCode;
                    edgeCodeCache.setDown(sheet.edgeDown.edgeCode);
                    sheet.edgeDown.edgeCode = "";
                    sheet.edgeLeft.edgeCode = edgeCodeCache.left || defaultEdgeCode;
                    sheet.edgeRight.edgeCode = edgeCodeCache.right || defaultEdgeCode;
                    update(index, sheet);
                }}> <img src="./my-icons/edge-3-sides-width.svg" width={size} alt="3 width"></img> </Button>
        </Stack>
    </Stack>;
}

